<template>
  <div class="page-content">
    <div class="search-form" style="margin-top: 10px;">
      <!-- 国家选择 -->
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label" style="line-height: 30px;padding: 3px 0px;">类型：</div>
          <div class="search-form-field-content v-center">
            <div
                class="tag-select-item"
                v-for="country in types"
                :key="country.code"
                :class="{'selected': selectedType === country.code, 'color-blue': country.blue}"
                @click="handleCountryChange(country.code)">
              {{ country.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="search-form-bottom">
        <el-button type="primary" @click="search">检索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div style="background-color: #FFFFFF;padding: 20px;margin-top: 20px;">
      <div class="enterprise-list">
        <div
            class="enterprise-card"
            v-for="item in enterprises"
            :key="item.id"
            @click="openRouter"
        >
          <div class="card-cover">
            <!-- 封面图，可用企业 banner / logo，也可以不用 -->
            <img :src="item.cover" :alt="item.name">
          </div>

          <div class="card-body">
            <div class="enterprise-name">
              {{ item.name }}
            </div>

            <div class="enterprise-tags">
            <span
                v-if="item.selfOwned"
                class="tag tag-self"
            >
              自营
            </span>
              <span
                  v-if="item.years"
                  class="tag tag-years"
              >
              {{ item.years }}年
            </span>
              <span
                  v-if="item.verified"
                  class="tag tag-verified"
              >
              已认证
            </span>
              <!-- 推荐星级 -->
              <span
                  v-if="item.verified"
                  class="tag tag-rating"
              >
                推荐：
                <span
                    v-for="n in 5"
                    :key="n"
                    class="star"
                    :class="{ filled: n <= item.rating }">
                  ★
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../api";

export default {
  name: "ServiceList",
  data() {
    return {
      constants: {},
      selectedType: '21',
      types: [ // 全部
        {code: '178', name: '信息化服务', blue: true},
        {code: '179', name: '门禁服务', blue: true},
        {code: '0', name: '设计搭建'},
        {code: '1', name: '展览工厂'},
        {code: '2', name: '展具租赁'},
        {code: '3', name: '礼仪模特'},
        {code: '4', name: '广告礼品'},
        {code: '5', name: '宾馆酒店'},
        {code: '6', name: '展品运输'},
        {code: '12', name: '旅游娱乐'},
        {code: '13', name: '印刷包装'},
        {code: '14', name: '法律保险'},
        {code: '21', name: '翻译服务', blue: true},
        {code: '22', name: '订票服务'},
        {code: '23', name: '代理招展'},
        {code: '24', name: '影视媒体'},
        {code: '25', name: '会议组织', blue: true},
        {code: '26', name: '营销策划'},
        {code: '27', name: '会展培训'},
        {code: '28', name: '综合服务'},
        {code: '29', name: '主场搭建'},
      ],
      enterprises: [
        {
          id: 1,
          name: '北京北辰会展信息服务有限公司',
          selfOwned: true,
          years: 10,
          verified: true,
          rating: 5,
          cover: require('@/assets/images/service/ssssdfds-322232332-4334334-4343434343.png')
        },
        {
          id: 2,
          name: '上海上外翻译总公司',
          selfOwned: true,
          years: 8,
          verified: true,
          rating: 4,
          cover: require('@/assets/images/service/143ded79-db77-4f2e-b612-d333f9ce4aca.png')
        },
        {
          id: 3,
          name: '中译语通科技（青岛）有限公司',
          selfOwned: true,
          years: 1,
          verified: true,
          rating: 4,
          cover: require('@/assets/images/service/0d2a60c4-af07-47dd-8947-d5bbe64ec237.png')
        },
        {
          id: 4,
          name: '上海联桥翻译服务有限公司',
          selfOwned: true,
          years: 4,
          verified: true,
          rating: 4,
          cover: require('@/assets/images/service/1e54250f-11cb-4257-baac-e01a94bcdd53.png')
        }
      ]
    }
  },
  methods: {
    // 处理国家选择变化
    handleCountryChange(countryCode) {
      if (countryCode=='21'){
        this.selectedType= countryCode
        this.enterprises = [
          {
            id: 1,
            name: '北京北辰会展信息服务有限公司',
            selfOwned: true,
            years: 10,
            verified: true,
            rating: 5,
            cover: require('@/assets/images/service/ssssdfds-322232332-4334334-4343434343.png')
          },
          {
            id: 2,
            name: '上海上外翻译总公司',
            selfOwned: true,
            years: 8,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/143ded79-db77-4f2e-b612-d333f9ce4aca.png')
          },
          {
            id: 3,
            name: '中译语通科技（青岛）有限公司',
            selfOwned: true,
            years: 1,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/0d2a60c4-af07-47dd-8947-d5bbe64ec237.png')
          },
          {
            id: 4,
            name: '上海联桥翻译服务有限公司',
            selfOwned: true,
            years: 4,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/1e54250f-11cb-4257-baac-e01a94bcdd53.png')
          }
        ]
      }else if (countryCode=='178') {
        this.selectedType= countryCode
        this.enterprises = [
          {
            id: 1,
            name: '北京北辰会展信息服务有限公司',
            selfOwned: true,
            years: 10,
            verified: true,
            rating: 5,
            cover: require('@/assets/images/service/ssssdfds-322232332-4334334-4343434343.png')
          },
          {
            id: 2,
            name: '成都励翔国际会展集团股份有限公司',
            selfOwned: true,
            years: 8,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/xxfw1.png')
          },
          {
            id: 3,
            name: '上海八彦图信息科技有限公司',
            selfOwned: true,
            years: 1,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/xxfw2.png')
          },
          {
            id: 4,
            name: '上海同高信息技术有限公司',
            selfOwned: true,
            years: 4,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/xxfw3.png')
          }
        ]
      }else if (countryCode=='179'){
        this.selectedType= countryCode
        this.enterprises = [
          {
            id: 1,
            name: '北京北辰会展信息服务有限公司',
            selfOwned: true,
            years: 10,
            verified: true,
            rating: 5,
            cover: require('@/assets/images/service/ssssdfds-322232332-4334334-4343434343.png')
          },
          {
            id: 2,
            name: '熵基科技股份有限公司',
            selfOwned: true,
            years: 8,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/mj1.png')
          },
          {
            id: 3,
            name: '深圳达实智能股份有限公司',
            selfOwned: true,
            years: 1,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/mj2.png')
          },
          {
            id: 4,
            name: '深圳科松技术有限公司',
            selfOwned: true,
            years: 4,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/mj3.png')
          }
        ]
      }else if (countryCode=='25'){
        this.selectedType= countryCode
        this.enterprises = [
          {
            id: 1,
            name: '北京北辰会展信息服务有限公司',
            selfOwned: true,
            years: 10,
            verified: true,
            rating: 5,
            cover: require('@/assets/images/service/ssssdfds-322232332-4334334-4343434343.png')
          },
          {
            id: 2,
            name: '上海市国际展览（集团）有限公司',
            selfOwned: true,
            years: 8,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/hyzz1.png')
          },
          {
            id: 3,
            name: '环球智信（北京）国际会展有限公司',
            selfOwned: true,
            years: 1,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/hyzz2.png')
          },
          {
            id: 4,
            name: '青岛骏晟国际会展有限公司',
            selfOwned: true,
            years: 4,
            verified: true,
            rating: 4,
            cover: require('@/assets/images/service/hyzz3.png')
          }
        ]
      }
    },
    async search(){
      this.searchParams.hy=this.searchForm.hy
      if(this.searchForm.usedState){
        this.searchParams.usedState=this.searchForm.usedState==='已开业'
      }else{
        this.searchParams.usedState=null
        this.searchParams.usedFrom = null
        this.searchParams.usedEnd = null
      }
      this.searchParams.type=this.searchForm.type
      this.searchParams.mcLike=this.searchForm.mcLike
      this.searchParams.zhmcLike=this.searchForm.zhmcLike
      this.searchParams.minMj=this.searchForm.minMj
      this.searchParams.maxMj=this.searchForm.maxMj
      this.searchParams.country = this.selectedType
      this.searchParams.area = this.selectedRegion
      await this.loadData(1)
    },
    async reset(){
      this.searchForm.hy=[]
      this.searchForm.usedState=null
      this.searchForm.dateRange=null
      this.searchForm.mcLike=null
      this.searchForm.zhmcLike=null
      this.searchForm.type=null
      this.searchForm.minMj=undefined
      this.searchForm.maxMj=undefined
    },
    async loadData(page){
      const params={
        ...this.searchParams,
        page:page-1,
        size:10,
      }
      this.data=(await api.listChangguan(params)).data
    },
    openRouter(){
      const { href } = this.$router.resolve({
        path: '/service/details-d',
        query:{}
      });
      window.open(href, '_self', 'noopener');
    }
  }
};
</script>
<style scoped>

/* 推荐星级 */
.tag-rating {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.tag-rating .star {
  font-size: 12px;
  margin-left: 1px;
  color: #d1d5db;
}

.tag-rating .star.filled {
  color: #f59e0b;
}
/* 自定义样式 */
span {
  font-weight: bold;
  margin-right: 10px;
}
.el-radio-group {
  margin-right: 20px;
}
/* 自定义样式 */
span {
  font-weight: bold;
  margin-right: 10px;
}
* {
  box-sizing: border-box;
}

.enterprise-page {
  padding: 24px;
  background: #f5f7fb;
  color: #1f2933;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.page-title {
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: 600;
}

/* 整体列表布局：自适应多列卡片 */
.enterprise-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  grid-gap: 16px;
}

/* 单个卡片 */
.enterprise-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.18s ease-out;
}

.enterprise-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(15, 35, 95, 0.14);
}

/* 顶部封面图 */
.card-cover {
  height: 160px;
  background: #e2e8f0;
}

.card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

}

/* 底部内容 */
.card-body {
  padding: 16px 18px 18px;
}

.enterprise-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 标签区域 */
.enterprise-tags {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
}

.tag {
  font-size: 12px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.color-blue{
  color: #2563eb;
}
.selected{
  color: #ffffff !important;
}

/* 自营 */
.tag-self {
  background: rgba(59, 130, 246, 0.08);
  color: #2563eb;
}

/* 年限 */
.tag-years {
  background: rgba(234, 179, 8, 0.1);
  color: #ca8a04;
}

/* 已认证 */
.tag-verified {
  background: rgba(34, 197, 94, 0.08);
  color: #16a34a;
}
</style>
